<template>
  <div class="wlx-about-us-wrapper">
    <div class="ph-head-menu">
      <i class="wl-icon-zhuye1" @click="goHome"><span>首页</span></i>
      <span>></span>
      <span v-show="isTab == 1">中物联介绍</span>
      <span v-show="isTab == 2">培训评价组织资质</span>
    </div>
    <div class="about-us-main">
      <div class="new-center-top clearfix fl">
        <div class="new-top-nav" :style="{background:'url('+imgs+')'}">
          <h1 class="new-top-title fl">A</h1>
          <div class="fl" style="padding-left:4px;">
            <p class="new-top-navtitle">关于我们</p>
            <p class="new-top-ews">bout</p>
          </div>
        </div>
        <div class="new-center-tab">
          <div class="new-center-dynamic" @click="tabSwitch(1)" :class="{'class-back':isTab == 1}">
            中物联介绍
            <span class="wl-icon wl-icon-xiangyou fr"></span>
          </div>
          <div class="new-center-dynamic" @click="tabSwitch(2)" :class="{'class-back':isTab == 2}">
            培训评价组织资质
            <span class="wl-icon wl-icon-xiangyou fr"></span>
          </div>
        </div>
      </div>
      <div class="new-center-listnav">
        <h2 v-show="isTab == 1">中物联介绍</h2>
        <h2 v-show="isTab == 2">培训评价组织资质</h2>
        <div class="new-center-path">
          <div class="crumbs-text">
            <i class="wl-icon-zhuye1"></i>
            <span>当前位置：</span>
            <span @click="goHome" style="cursor: pointer;">网站首页</span>
            <span>></span>
            <span v-show="isTab == 1">中物联介绍</span>
            <span v-show="isTab == 2">培训评价组织资质</span>
          </div>
        </div>
      </div>
      <!-- 移动端导航切换 -->
      <div class="ph-head-menu-con clearfix">
        <div @click="tabSwitch(1)" class="fl sp-ph-head-change-btn" :class="{'class-back':isTab == 1}">中物联介绍</div>
        <div @click="tabSwitch(2)" class="fl sp-ph-head-change-btn" :class="{'class-back':isTab == 2}">培训评价组织资质</div>
      </div>
      <div class="new-center-list clearfix" v-if="isTab == 1">
        <p class="p-about-us-title">北京中物联物流采购培训中心简介</p>
        <p
          class="p-about-us-content"
        >中国物流与采购联合会(China Federation of Logistics & Purchasing 简称中物联或CFLP)，是经国务院批准设立的中国第一家物流与采购行业社团组织，总部设在北京。中物联的主要任务是推动中国物流业的发展，推动政府与企业采购事业的发展，推动生产资料流通领域的改革与发展，完成政府委托交办事项。政府有关部门授予中物联外事、科技、教育、培训、职业资格行业统计和标准制修订等项职能。中物联是亚太物流联盟和国际采购联盟的中国代表，并与许多国际同行有着广泛的联系与合作。</p>
        <p
          class="p-about-us-content"
        >北京中物联物流采购培训中心（以下简称“培训中心”）成立于2002年，是中物联下设业务部门。自成立以来，培训中心一直致力于物流、采购、供应链管理领域的专业人才培养，以知识更新和技能提升为路径，已发展成为在物流、采购与供应链管理相关领域上最具竞争力的培训服务机构。在中物联的指导下，培训中心秉承服务企业、服务行业、服务院校的理念，承接中物联物流、采购、供应链管理证书培训项目，并积极开展企业内训服务。培训中心视培训工作的质量视为生命，规范化运作和管理，坚持培训质量优先，坚持以为社会培养有用人才为根本目标，全面掌握物流学科人才培养与企业用人需求，大力推动产、学、研结合，引领物流、采购和供应链学科及专业建设。</p>
      </div>
      <div class="new-center-list clearfix" v-if="isTab == 2">
        <img
          src="https://file.clpp.org.cn/66ykt/ori/quioalgoh5bdatisgfv7sq/xCAGWYwakd65Mc7P.jpg"
          alt
        >
        <img
          src="https://file.clpp.org.cn/66ykt/ori/quioalgoh5bdatisgfv7sq/h4tnFEDw6hSE5WEA.jpg"
          alt
        >
        <img
          src="https://file.clpp.org.cn/66ykt/ori/quioalgoh5bdatisgfv7sq/j5SJ74aGktJYDnik.jpg"
          alt
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgs: require("../../assets/images/bg-about.png"),
      isTab: 1,
      pageSize: 10,
      type: 1,
      totalCount: 0,
      currentPage4: 1,
      newsList: []
    };
  },
  created() {
    if (this.$route.params.isTab == undefined) {
      this.isTab = 1;
      this.type = 1;
    } else {
      this.isTab = this.$route.params.isTab;
      this.type = this.$route.params.isTab;
    }
  },
  computed: {
    association: function() {
      return this.$store.state.association;
    }
  },
  methods: {
    tabSwitch(type) {
      this.type = type;
      this.isTab = type;
    },
    goNewsDetail(newsId) {
      this.$router.push({
        name: "newsDetail",
        params: {
          newsId: newsId,
          isTab: this.type
        }
      });
    },
    goHome() {
      this.$router.push({
        name: "xHome"
      });
    }
  }
};
</script>

<style>
</style>
